module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMTAiIHdpZHRoPSIyMyIgaGVpZ2h0PSI5IiByeD0iMSIgc3Ryb2tlPSIjMUE4NUU0IiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTIyLjQzMyAxNS4yNUMyMi4yNDA2IDE1LjU4MzMgMjEuNzU5NCAxNS41ODMzIDIxLjU2NyAxNS4yNUwyMC43MDEgMTMuNzVDMjAuNTA4NSAxMy40MTY3IDIwLjc0OTEgMTMgMjEuMTM0IDEzTDIyLjg2NiAxM0MyMy4yNTA5IDEzIDIzLjQ5MTUgMTMuNDE2NyAyMy4yOTkgMTMuNzVMMjIuNDMzIDE1LjI1WiIgZmlsbD0iIzFBODVFNCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/field-icon-active/single_selection.svg
// module id = +Ckq
// module chunks = 46